import { useCapabilities } from '@office-start/capabilities-service';
import { useOfficeComponentContext } from '@office-start/component-context-service';
import { useIdentity } from '@office-start/identity-service';
import { useInstallConfig } from '@office-start/install-config-service';
import { useMemo } from 'react';
export var useWarmupDimeOptions = function () {
    var componentContext = useOfficeComponentContext().data;
    var installConfig = useInstallConfig().data;
    var capabilities = useCapabilities().data;
    var identity = useIdentity().data;
    return useMemo(function () {
        if (!componentContext || !installConfig || !capabilities || !identity) {
            return undefined;
        }
        return {
            dimeJSUrl: installConfig.dimeJSUrl,
            dimeTimeoutMs: installConfig.dimeTimeoutMs,
            preferredCulture: componentContext.preferredCulture,
            puid: identity.puid,
            pwaEnabled: capabilities.pwaEnabled,
            sessionId: componentContext.sessionId,
            upn: identity.userPrincipalName || '',
        };
    }, [capabilities, componentContext, installConfig, identity]);
};
//# sourceMappingURL=useWarmupDimeOptions.js.map